import algoliasearch from "algoliasearch";
import * as config from "../../config/config.json";

export const algoliaClientSearch = (key: string) => {
  const searchClient = algoliasearch(config.algolia.appId, config.algolia.apiKey);
  return searchClient.initIndex(key);
}